export default "__VITE_ASSET__MWMN40GK__"